import { render, staticRenderFns } from "./BaseTreeSelectTopic.vue?vue&type=template&id=41b2c5c7&"
import script from "./BaseTreeSelectTopic.vue?vue&type=script&lang=js&"
export * from "./BaseTreeSelectTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports